import * as _ from "lodash";
import { ProfessionalLinkLinkStatus } from "./professional-link";

export interface SetProfessionalStatusResponseEntry {
    newStatus?: ProfessionalLinkLinkStatus;
    error: "not found" | "database" | null;
}

export type SetProfessionalStatusResponse = _.NumericDictionary<SetProfessionalStatusResponseEntry>;
